<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-contact></app-breadcrumb-contact>
    <app-contact-section></app-contact-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
